import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-005b4edb"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "catalog-service-accordeon-card-wrapper" };
const _hoisted_2 = { class: "catalog-service-accordeon-card-header" };
const _hoisted_3 = { class: "flex flex-row align-items-center" };
const _hoisted_4 = { class: "catalog-service-accordeon-card-title" };
const _hoisted_5 = { class: "catalog-service-accordeon-card-description" };
const _hoisted_6 = { style: { "display": "flex", "flex-direction": "column", "gap": "10px", "align-items": "baseline" } };
const _hoisted_7 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_8 = { class: "flex flex-row justify-content-between" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "font-bold mb-3" }, " Resources ", -1));
import { ref, onMounted, onUnmounted, } from "vue";
import { useRouter } from "vue-router";
import Tag from "primevue/tag";
import Card from "primevue/card";
import ImageWithNoImageDefault from "@/components/atoms/ImageWithNoImageDefault.vue";
import OneDeskLinks from "@/components/molecules/OneDeskLinks.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CatalogServiceCard',
    props: {
        data: {}
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const showRollover = ref(false);
        const cardClass = ref("col-6");
        const cardRef = ref();
        const toggleLinks = ref(false);
        const myEventHandler = () => {
            if (cardRef.value && cardRef.value.clientWidth > 0) {
                if (cardRef.value.clientWidth < 253 ||
                    (cardRef.value.clientWidth >= 527 &&
                        cardRef.value.clientWidth < 554) ||
                    (cardRef.value.clientWidth >= 752 &&
                        cardRef.value.clientWidth < 1150))
                    cardClass.value = "col-12";
                else
                    cardClass.value = "col-6";
            }
        };
        onMounted(() => {
            window.addEventListener("resize", myEventHandler);
            myEventHandler();
        });
        onUnmounted(() => {
            window.removeEventListener("resize", myEventHandler);
        });
        const onViewCardClick = () => {
            router.push({
                name: "CardDetailsPage",
                params: { cardId: props.data.id },
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Card), {
                    class: "catalog-service-accordeon-card",
                    ref_key: "cardRef",
                    ref: cardRef,
                    onMouseover: _cache[1] || (_cache[1] = ($event) => (showRollover.value = true)),
                    onMouseleave: _cache[2] || (_cache[2] = ($event) => (showRollover.value = false))
                }, {
                    title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                (_ctx.data.pictureUri)
                                    ? (_openBlock(), _createBlock(ImageWithNoImageDefault, {
                                        key: 0,
                                        source: _ctx.data.pictureUri
                                    }, null, 8, ["source"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.title), 1)
                            ]),
                            _createElementVNode("i", {
                                class: "pi pi-eye",
                                style: { "cursor": "pointer", "color": "var(--cyan-500)" },
                                onClick: onViewCardClick
                            })
                        ])
                    ]),
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.description), 1),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(Tag), {
                                icon: "pi pi-globe",
                                severity: "secondary",
                                value: _ctx.data.scope
                            }, null, 8, ["value"]),
                            _createVNode(_unref(Tag), {
                                icon: "pi pi-users",
                                severity: "secondary",
                                value: _ctx.data.audience
                            }, null, 8, ["value"])
                        ]),
                        (_ctx.data.links.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createElementVNode("i", {
                                        class: _normalizeClass(toggleLinks.value ? 'pi pi-chevron-up' : 'pi pi-chevron-down'),
                                        style: { "cursor": "pointer", "color": "var(--cyan-500)" },
                                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleLinks.value = !toggleLinks.value))
                                    }, null, 2)
                                ]),
                                (toggleLinks.value)
                                    ? (_openBlock(), _createBlock(OneDeskLinks, {
                                        key: 0,
                                        links: _ctx.data.links
                                    }, null, 8, ["links"]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512)
            ]));
        };
    }
});
